export default class InputUpdateStatus
{
  constructor(id, status) 
  {
    this.id = id;
    this.status = status;
  }    
}